import React from 'react';
import { Navigate, useNavigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import AppArtwork from '../components/AppArtwork';

const LoginPage = () => {
  const { login, authBypassActive, user, loading } = useAuth();
  const navigate = useNavigate();
  const [isRedirecting, setIsRedirecting] = React.useState(false);

  const handleLogin = () => {
    setIsRedirecting(true);
    if (authBypassActive) {
      login();
      navigate('/dashboard');
      return;
    }
    login();
  };

  if (!loading && user) {
    return <Navigate to="/dashboard" replace />;
  }

  return (
    <section className="login-shell fade-in">
      <div className="login-container">
        <AppArtwork />
        <p className="eyebrow">Welcome back</p>
        <h1>Sign in to DocMerge</h1>
        <p className="muted">Authenticate with your configured identity provider.</p>
        <button onClick={handleLogin} disabled={isRedirecting} className="btn-primary">
          {isRedirecting ? 'Redirecting...' : 'Continue with SSO'}
        </button>
      </div>
    </section>
  );
};

export default LoginPage;
